import { lgExtension } from '@cbsinteractive/avia-js-lg';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { AviaExtension } from 'tag/ts/tag/player/adapters/avia/extensions/AviaExtension';
import { IAviaExtension } from 'tag/ts/tag/player/adapters/avia/interfaces/IAviaExtension';

export class LgCapabilitiesExtension extends AviaExtension implements IAviaExtension {
	package = lgExtension;
	namespaceKey = 'plugin_lg';

	constructor( argument: ITagAbstractClassArgument ) {
		super( {
			...argument,
			name: 'LgCapabilitiesExtension'
		} );
	}

	shouldBeUsed() {
		if ( !super.shouldBeUsed() ) return false;

		const lgAPIExists = navigator?.userAgent?.includes?.( 'Web0S' )
			|| this.utils.Type.isDefined( window?.webOS?.deviceInfo )
			|| this.utils.Type.isDefined( window?.webOSSystem?.deviceInfo )
			|| this.utils.Type.isDefined( window?.PalmSystem?.deviceInfo );
		const html5Embed = this?.params?.SYSTEM?.embedType === EmbedType.HTML5;

		if ( html5Embed && lgAPIExists ) {
			this?.logger?.log(
				'LG API detected:',
				'navigator?.userAgent',
				navigator?.userAgent,
				'window?.webOS?.deviceInfo',
				window?.webOS?.deviceInfo,
				'window?.webOSSystem?.deviceInfo',
				window?.webOSSystem?.deviceInfo,
				'window?.PalmSystem?.deviceInfo',
				window?.PalmSystem?.deviceInfo
			);
		}

		return html5Embed && lgAPIExists;
	}
}